import { MdChevronRight } from "react-icons/md";
import Avatar from "../avatar";
import Buttons from "@ui/buttons";
import Link from "next/link";

export default function UserCard({ auth }) {
    return (
        <Link href={'/profile'} className={`flex cursor-pointer flex-row items-center gap-4 bg-[#3232C2] p-2 rounded-lg`}>
            <Avatar/>
            <div className={`flex flex-col gap-2 text-white flex-1`}>
                <span className={`text-sm font-bold`}>{auth?.profile?.username}</span>
                <span className={`text-sm font-light`}>View Profile</span>
            </div>
            <Buttons.Round className={`shrink-0 bg-[#7F7FD4]`}>
                <MdChevronRight className={`text-white text-2xl`}/>
            </Buttons.Round>
        </Link>
    );
}